const STAGE = [
  {
    name: '基础阶段',
    startTime: '基础知识的学习',
    body: [
      {
        week: '《小卓的妖孽人生》',
        detail: [
          {
            days: 1,
            content:
              '零基础同学学习课本《小卓的妖孽人生》，通读全文。有初级会计职称的同学可以选择性跳过。',
          },
        ],
      },
      {
        week: '《实操基础入门》',
        detail: [
          {
            days: 3,
            content:
              '听《实操基础入门》录播课程（视频位置：卓考网校APP【首页-基础知识篇】）',
          },
        ],
      },
    ],
  },
  {
    name: '实操阶段',
    startTime: '将理论运用实际当中',
    body: [
      {
        week: '基础理论',
        detail: [
          {
            days: 3,
            content: '听第一章录播课程，结合实操课本第一章学习实操基础知识',
          },
        ],
      },
      {
        week: '商贸小规模手工帐',
        detail: [
          {
            days: 1,
            content: '根据业务事项填写记账凭证、在空白练习账簿登账',
          },
          {
            days: 2,
            content:
              '听第二章第一节录播课程，结合实操课本第二章第一节学习手工帐',
          },
          {
            days: 1,
            content: '按照正确的入账方式重新做帐，巩固实操基础',
          },
        ],
      },
      {
        week: '商贸小规模电子账',
        detail: [
          {
            days: 1,
            content:
              '听第二章第二节《财务软件的安装》录播课程，安装财务软件并新建账套，熟悉软件的各个核算模块',
          },
          {
            days: 1,
            content: '自己根据业务发生的原始单据录制凭证',
          },
          {
            days: 2,
            content:
              '听录播视频，学习业务事项的凭证录入、审核、结账等实际操作步骤',
          },
          {
            days: 1,
            content: '课程全部学完之后，再重新练习电子账实操',
          },
        ],
      },
      {
        week: '工业电子账',
        detail: [
          {
            days: 1,
            content: '自己根据业务发生的原始单据录制凭证',
          },
          {
            days: 2,
            content:
              '听第三章录播课程，学习业务事项的凭证录入、审核、结账等实际操作步骤',
          },
          {
            days: 1,
            content: '课程全部学完之后，再重新练习电子账实操',
          },
        ],
      },
      {
        week: '直播课程',
        detail: [
          {
            days: 2,
            content:
              '按照模块进行针对性学习，不明白的地方及时在直播间提问，与老师互动。（直播课程在卓考网校APP【专题直播】）',
          },
        ],
      },
      {
        week: 'Excel专题课',
        detail: [
          {
            days: 1,
            content: '对Excel感兴趣的同学可以学习录播课程《Excel专题课》',
          },
        ],
      },
      {
        week: '复习',
        detail: [
          {
            days: 1,
            content: '复习全书所学内容，实际操作练习',
          },
        ],
      },
    ],
  },
];

export default STAGE;
